import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {UserInfoStorageService} from '../../../services/auth/user-info-storage.service';
import {CrystalClearFrontUrl} from '../../../shared/pages/crystal-clear-front-url';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderActionService} from '../../../services/header-action.service';
import {ToastService} from '../../../services/toast-service';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CrystalClearFrontUrlCustomer} from '../../../shared/pages/crystal-clear-front-url-customer';
import {CrystalClearFrontUrlTools} from '../../../shared/pages/crystal-clear-front-url-tools';
import {PageDescription} from "../../../shared/pages/page-description";
import {CrystalClearFrontUrlExchange} from "../../../shared/pages/crystal-clear-front-url-exchange";
import {CrystalClearFrontUrlMapping} from "../../../shared/pages/crystal-clear-front-url-mapping";
import {ThemeService} from "../../../services/tools/theme.service";
import {HeaderMenuBaseComponent} from "./header-menu-base.component";
import {CrystalClearFrontUrlETicket} from "../../../shared/pages/crystal-clear-front-url-eticket";
import {CcStorageService} from "../../../services/common/cc-storage.service";
import {CrystalClearFrontUrlSupport} from "../../../shared/pages/crystal-clear-front-url-support";
import {AppConfigService} from "../../../services/app-config.service";


@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    TranslateService,
  ]
})
export class HeaderMenuComponent extends HeaderMenuBaseComponent {

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              authService: UserInfoStorageService,
              router: Router,
              headerActionService: HeaderActionService,
              route: ActivatedRoute,
              toastService: ToastService,
              translateService: TranslateService,
              storageService: CcStorageService,
              themeService: ThemeService,
              public appConfigService: AppConfigService) {
    super(cdref,messageService, authService, router, headerActionService, route, toastService, translateService, storageService, themeService);

  }

  protected initMenuItems() {
    if (this.userInfo) {
      let recapPage: PageDescription = CrystalClearFrontUrl.ARCHIVE_RECAP_PROFILE;
      if (!PageDescription.isVisible(this.userInfo.roles, recapPage))
        recapPage = CrystalClearFrontUrl.ARCHIVE_RECAP_FORM;
      recapPage = {
        label: 'page_title.recap.header',
        roles: recapPage.roles,
        path: recapPage.path,
        icon: recapPage.icon
      };
      let reportPage: PageDescription = CrystalClearFrontUrl.ARCHIVE_REPORT_FORM;
      if (!PageDescription.isVisible(this.userInfo.roles, reportPage))
        reportPage = CrystalClearFrontUrl.ARCHIVE_REPORT_PROFILE;
      reportPage = {
        label: 'page_title.archive.header',
        roles: reportPage.roles,
        path: reportPage.path,
        icon: reportPage.icon,
      };
      let billingPage: PageDescription = CrystalClearFrontUrl.ARCHIVE_BILLING_LIST;
      if (!PageDescription.isVisible(this.userInfo.roles, billingPage))
        billingPage = CrystalClearFrontUrl.ARCHIVE_BILLING_LIST;
      billingPage = {
        label: 'page_title.billing.header',
        roles: billingPage.roles,
        path: billingPage.path,
        icon: billingPage.icon
      };
      this.menuBarItemsLeft = [
        this.toMenuItem(CrystalClearFrontUrl.TRADES_ORDERS, true),
        // E-Ticket
        this.toMenuItem(CrystalClearFrontUrlETicket.NEW_ETICKET, false, [], this.appConfigService.eticketEnabled),
        this.toMenuItem(CrystalClearFrontUrlETicket.LIST_ETICKET, false, [], this.appConfigService.eticketEnabled),
        // NOT READY this.toMenuItem(CrystalClearFrontUrl.ORDERS_POF, false),
        this.toMenuItem(recapPage, false),
        this.toMenuItem(reportPage, false, [
          this.toMenuItem(CrystalClearFrontUrl.SECURITY_USER, false),
          this.toMenuItem(CrystalClearFrontUrl.SECURITY_USER_GROUP, false),
          this.toMenuItem(CrystalClearFrontUrlTools.TOOLS_NOTIFY, false, [], this.appConfigService.notificationEnabled),
          this.toMenuItem(CrystalClearFrontUrlTools.TOOLS_SCHEDULER, false, [], this.appConfigService.schedulerEnabled),
          this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_SYNC, false, [], this.appConfigService.supportEnabled),
          this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_TOC, false, [], this.appConfigService.supportEnabled),
        ]),
        this.toMenuItem(billingPage, false, [], this.appConfigService.billingEnabled),
      ];

      this.menuBarItemsRight = [
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER, false),
        this.toMenuItem(CrystalClearFrontUrlExchange.EXCHANGE, false),
        this.toMenuItem(CrystalClearFrontUrlMapping.MAPPING, false),
        this.toMenuItem(CrystalClearFrontUrlTools.TOOLS, true,
          [
            this.toMenuItem(CrystalClearFrontUrl.SECURITY_USER, false),
            this.toMenuItem(CrystalClearFrontUrl.SECURITY_USER_GROUP, false),
            this.toMenuItem(CrystalClearFrontUrlTools.TOOLS_NOTIFY, false, [], this.appConfigService.notificationEnabled),
            this.toMenuItem(CrystalClearFrontUrlTools.TOOLS_SCHEDULER, false, [], this.appConfigService.schedulerEnabled),
            this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_SYNC, false, [], this.appConfigService.supportEnabled),
            this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_TOC, false, [], this.appConfigService.supportEnabled),
          ]),
      ];
      this.refreshActiveMenu(this.router.url.substring(1));
    }
  }

}
